module.exports = __webpack_public_path__ + "static/media/snappy-desktop.c81ca006.svg";